'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main', {
    url: '/',
    template: '<main></main>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/main/main.routes.js